// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linesHeaderStyles } from "@steiner/App/Components/Cart/LinesHeader";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, getSystemColor, hideElementOnPrint, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

linesHeaderStyles.wrapper = {
    css: css`
        display: grid;
        grid-template-columns: 64px minmax(0, 1fr) minmax(0, 124px) minmax(0, 180px) minmax(0, 124px) minmax(0, 150px) minmax(0, 36px);
        &[data-has-qty-shipped="true"] {
            grid-template-columns: 64px minmax(0, 1fr) minmax(0, 180px) minmax(0, 100px) minmax(0, 100px) minmax(0, 150px) minmax(0, 36px);
        }
        grid-column-gap: 12px;
        grid-auto-flow: column;
        background: ${color("common.ui10")};
        font-size: 12px;
        line-height: 17px;
        color: ${color("common.ui1")};
        font-weight: ${fontConfig.weight.bold};
        width: 100%;
        padding: 0 12px;

        @media print {
            color: ${getSystemColor("common.ui1")};
            background: ${getSystemColor("common.ui10")};
        }

        ${xScreen("lte", "md")} {
            display: none;
        }
        ${hideElementOnPrint}
    `,
};
linesHeaderStyles.productInformation = {
    css: css`
        padding: 5px 0 6px;
        grid-column: 1 / 3;
    `,
};
linesHeaderStyles.inventory = {
    css: css`
        padding: 5px 12px 6px;
        grid-column: 3 / 4;
    `,
};
linesHeaderStyles.price = {
    css: css`
        padding: 5px 12px 6px;
        grid-column: 4 / 5;
        &[data-has-qty-shipped="true"] {
            grid-column: 3 / 4;
        }
    `,
};
linesHeaderStyles.qty = {
    css: css`
        white-space: nowrap;
        padding: 5px 12px 6px;
        grid-column: 5 / 6;
        &[data-has-qty-shipped="true"] {
            grid-column: 4 / 5;
        }
    `,
};

linesHeaderStyles.qtyShipped = {
    css: css`
        white-space: nowrap;
        padding: 5px 12px 6px;
        grid-column: 6 / 7;
        display: none;
        &[data-has-qty-shipped="true"] {
            display: block;
            grid-column: 5 / 6;
        }
    `,
};

linesHeaderStyles.extPrice = {
    css: css`
        padding: 5px 12px 6px;
        grid-column: 6 / 7;
        &[data-has-qty-shipped="true"] {
            grid-column: 6 / 7;
        }
    `,
};
